import type { BuildStepFailure } from '../api/client'

type UnfulfilledWishCardProps = {
  failure: BuildStepFailure
  onSuggestionClick?: (suggestion: string) => void
}

const formatLabel = (value: string) =>
  value
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (letter) => letter.toUpperCase())

export function UnfulfilledWishCard({ failure, onSuggestionClick }: UnfulfilledWishCardProps) {
  const hasAlternatives = failure.available_alternatives.length > 0

  return (
    <article className="unfulfilled-wish-card">
      <div className="unfulfilled-icon">
        <span className="part-type-icon">{failure.part_type.slice(0, 2).toUpperCase()}</span>
      </div>

      <div className="unfulfilled-body">
        <div className="unfulfilled-header">
          <span className="unfulfilled-type">{formatLabel(failure.part_type)}</span>
          <span className="unfulfilled-badge">Unavailable</span>
        </div>

        <p className="unfulfilled-reason">{failure.reason}</p>

        {failure.suggestion && (
          <p className="unfulfilled-suggestion">{failure.suggestion}</p>
        )}

        {hasAlternatives && (
          <div className="alternatives-section">
            <p className="alternatives-label">Available alternatives:</p>
            <div className="alternatives-chips">
              {failure.available_alternatives.map((alt) => (
                <button
                  key={alt}
                  type="button"
                  className="alternative-chip"
                  onClick={() => onSuggestionClick?.(
                    `What about a ${alt} ${failure.part_type} instead?`
                  )}
                >
                  {formatLabel(alt)}
                </button>
              ))}
            </div>
          </div>
        )}

        {!hasAlternatives && (
          <p className="no-alternatives-note">
            No alternatives found — try adjusting your requirements and I'll search again.
          </p>
        )}
      </div>
    </article>
  )
}